// eslint-disable-next-line import/prefer-default-export
export const baseUrl = 'https://apiv2.sorrba.org/artemis';
// export const baseUrl = 'http://localhost:9005/artemis';
